import Vue from 'vue'
import jwtDecoder from 'jwt-decode'
import {ENV} from '../config'
import REGEX from '@/global/utilities.js'
import storageMixin  from './storageMixin'

Vue.mixin({
  methods: {
    getUsername() {
      const _token = storageMixin.methods.getTokenFromStorage()
      const _decodedToken = jwtDecoder(_token)
      const {username} = _decodedToken
      return username
    },
    getLoggedInUser() {
      const _token = storageMixin.methods.getTokenFromStorage()
      if (!_token) {
        return null
      }
      const _decodedToken = jwtDecoder(_token)
      return _decodedToken
    },
    getInitials(firstName, lastName) {
      if (firstName && lastName) {
        const _first = firstName.split('').shift()
        const _last = lastName.split('').shift()
        return _first + _last
      }
      return '--'
    },
    isProductionEnvironment() {
      return ENV.environment === 'production'
    },
    generateAddressGroup(parentAddress, numberOfDevices) {
      /* eslint-disable no-loops/no-loops */
      const _addresses = [parentAddress]
      const baseHex = 16
      for (let i = 0; i < numberOfDevices; i++) {
        const _addressHexString = _addresses[i].split(':').join('')
        const _incrementedInt = parseInt(_addressHexString, baseHex) + 1
        const _newAddress = this.createMacAddress(_incrementedInt)
        _addresses.push(_newAddress)
      }
      return _addresses
      /* eslint-enable no-loops/no-loops */
    },
    createMacAddress(macNumber) {
      /* eslint-disable no-magic-numbers */
      return macNumber
        .toString(16)
        .padStart(12, '0')
        .match(/../g)
        .reverse()
        .slice(0, 6)
        .reverse()
        .join(':')
      /* eslint-enable no-magic-numbers */
    },
    isEmptyString(string) {
      return !string || string.trim().length === 0
    },
    isAlphaNumeric(string) {
      return !this.isEmptyString(string) && REGEX.alphaNumeric.test(string)
    },
    deepCopy(object) {
      return JSON.parse(JSON.stringify(object))
    },
    convertSecondsToMmss(s) {
      if (s === 0) {
        return '0s'
      }

      const min = Math.floor(s / 60)
      const seconds = s % 60

      let formatted = min > 0 ? `${min}min ` : ''
      formatted += seconds > 0 ? `${seconds}s` : ''

      return formatted
    },
    getNumberOfChildren(type) {
      switch (type) {
      case 'safe':
        return 0
      case 'cabinet':
        return 1
      case 'door':
        return 3
      default:
        throw new Error('Invalid type')
      }
    },
  },
})
